import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import stylesPc from "./SelectGroup.module.css";
import stylesSp from "./SelectGroup_SP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import {
    FormControl,
    InputLabel,
    FilledInput,
    InputAdornment,
    createStyles,
    makeStyles,
    Theme,
    Checkbox,
    FormControlLabel,
    Chip,
    Divider,
    ThemeProvider,
    createTheme,
} from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { Group } from "../../../user/User";
import { GetGroupList } from "../../../user/UserActions";
import CheckedIcon from "../../../assets/image/CheckedIcon";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        searchTitle: {
            fontSize: "16px",
        },
        searchInput: {
            height: "55px",
            fontSize: "20px",
            borderRadius: "3px",
        },
        searchButton: {
            fontSize: "1rem",
            borderRadius: "5px",
            marginRight: "15px",
            backgroundColor: "var(--red)",
            "&:hover": {
                backgroundColor: "rgb(193, 0, 25)",
            },
        },
        addButton: {
            fontSize: "1rem",
            borderRadius: "5px",
            backgroundColor: "var(--red)",
            "&:hover": {
                backgroundColor: "rgb(193, 0, 25)",
            },
        },
    })
);

const theme = createTheme({
    palette: {
        secondary: {
            main: "#12e07e",
        },
    },
});

interface SelectGroupProps {
    visibleModal: boolean;
    onClose?: () => void;
    targetName: string;
    userGroup: Group[];
    SetGroupList: (userGroup: Group[]) => void;
    SetIsSaved?: (flg: boolean) => void;
}

const SelectGroup = React.forwardRef<HTMLDivElement, SelectGroupProps>(function SelectGroup(
    props,
    ref
) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const { visibleModal, onClose, targetName, SetGroupList, userGroup, SetIsSaved } = props;
    const classes = useStyles();
    const dispatch = useDispatch();

    const { groupList } = useSelector((state: AppState) => ({
        groupList: state.user.groupList,
    }));

    const [displayGroupList, ChangeDisplayGroupList] = React.useState<string[]>([]);
    const [searchKey, setSearchKey] = React.useState("");
    const [editGroup, ChangeEditGroup] = useState<Group[]>(userGroup);

    const InputSearchGroup = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchKey(event.currentTarget.value.trim());
    };

    useEffect(() => {
        if (groupList.length === 0 && visibleModal) {
            dispatch(GetGroupList());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visibleModal]);

    // 検索していないときはすべてのグループを表示する、検索時はフィルター結果のみ表示する
    useEffect(() => {
        const groupNameList = groupList?.map(function (row) {
            return row.title;
        });
        const searchGroup = groupNameList.filter(
            (groupName) => groupName.indexOf(searchKey) !== -1
        );
        ChangeDisplayGroupList(
            searchGroup.length !== 0 || searchKey.length !== 0 ? searchGroup : groupNameList
        );
    }, [groupList, searchKey]);

    const DeleteGroup = (deleteGroupName: string) => () => {
        ChangeEditGroup(editGroup.filter((v) => v.title !== deleteGroupName));
    };

    const CheckGroup = (event: React.ChangeEvent<HTMLInputElement>) => {
        let tempList = editGroup;
        if (!event.currentTarget.checked) {
            tempList = tempList.filter((v) => v.title !== event.currentTarget.name);
        } else {
            const addGroup = groupList.filter((v) => v.title === event.currentTarget.name);
            if (tempList && tempList.length > 0) {
                tempList = tempList.concat(addGroup);
            } else {
                tempList = addGroup;
            }
        }
        ChangeEditGroup(tempList);
    };

    const isChecked = (item: string) => {
        if (editGroup && editGroup.length > 0) {
            const element = editGroup.find((el) => el.title === item);
            if (element) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    // 編集完了
    const ConfirmGroup = () => {
        if (onClose) {
            SetGroupList(editGroup);
            if (SetIsSaved) {
                SetIsSaved(false);
            }
            onClose();
        }
    };

    const handleCancel = () => {
        if (onClose) onClose();
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                {!IsDevice("desktop") && (
                    <div onClick={onClose} className={styles.closeButton}>
                        <img src={require("../../../assets/image/closeFilter.svg")} alt="close" />
                    </div>
                )}
                <div className={styles.root}>
                    <div className={styles.conditionArea}>
                        <div style={{ display: "block", marginBottom: "15px" }}>
                            <h2>対象: {targetName}</h2>
                            <h2>
                                所属Group数:{" "}
                                {editGroup && editGroup.length > 0 ? editGroup.length : 0}
                            </h2>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                {editGroup &&
                                    editGroup.length > 0 &&
                                    editGroup.map((group) => (
                                        <div
                                            key={group.id}
                                            style={{ marginRight: "7px", marginTop: "5px" }}
                                        >
                                            <Chip
                                                label={group.title}
                                                color="secondary"
                                                style={{
                                                    color: "#fff",
                                                    backgroundColor: "var(--main)",
                                                }}
                                                size="medium"
                                                className={styles.tag}
                                                onDelete={DeleteGroup(group.title)}
                                            />
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                    <div className={styles.skillArea}>
                        <Divider variant="middle" />
                        <h2>Groupの追加</h2>
                        <h2>■登録されているGroupから追加</h2>
                        <FormControl fullWidth variant="filled" color="secondary">
                            <InputLabel htmlFor="searchInput" className={classes.searchTitle}>
                                検索したいGroupを入力
                            </InputLabel>
                            <FilledInput
                                id="searchInput"
                                onChange={InputSearchGroup}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <Search
                                            color="secondary"
                                            style={{ color: "var(--main)" }}
                                        />
                                    </InputAdornment>
                                }
                                autoComplete={"off"}
                                className={classes.searchInput}
                            />
                        </FormControl>
                        <div className={styles.skillScrollArea}>
                            {displayGroupList &&
                                displayGroupList.map((item, index) => (
                                    <FormControlLabel
                                        key={index}
                                        control={
                                            <Checkbox
                                                checkedIcon={
                                                    <div className={styles.checkedIcon}>
                                                        <CheckedIcon />
                                                    </div>
                                                }
                                                name={item}
                                                checked={isChecked(item)}
                                                onChange={CheckGroup}
                                            />
                                        }
                                        label={item}
                                        className={styles.skillCheckBox}
                                    />
                                ))}
                        </div>
                    </div>
                    <div className={styles.btnArea}>
                        <Button
                            size="small"
                            variant="outlined"
                            type="submit"
                            onClick={handleCancel}
                            style={{
                                marginRight: "10px",
                                color: "var(--gray-42)",
                                borderColor: "var(--gray-42)",
                            }}
                        >
                            キャンセル
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            className={classes.searchButton}
                            onClick={ConfirmGroup}
                            disabled={editGroup === props.userGroup}
                            style={{
                                backgroundColor:
                                    editGroup === props.userGroup
                                        ? "rgba(0, 0, 0, 0.12)"
                                        : "var(--main)",
                                color:
                                    editGroup === props.userGroup
                                        ? "rgba(0, 0, 0, 0.26)"
                                        : "var(--white)",
                            }}
                        >
                            編集完了
                        </Button>
                    </div>
                </div>
            </ThemeProvider>
        </>
    );
});
export default SelectGroup;
